// Display helpers shared by the recommendation surfaces.

// FastAPI validation errors return an array of objects, which React cannot render.
export const formatApiError = (detail) => {
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => e?.msg).filter(Boolean).join('. ') || 'Something went wrong';
  }
  return 'Something went wrong';
};

export const initialsOf = (name) => {
  const parts = (name || '').trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '?';
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

export const firstNameOf = (name) => (name || '').trim().split(/\s+/)[0] || 'they';

const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());

// Today / Yesterday / N days ago for the last week, then a plain calendar date.
export const formatRecDate = (createdAt) => {
  const date = new Date(createdAt);
  if (Number.isNaN(date.getTime())) return '';
  const days = Math.round((startOfDay(new Date()) - startOfDay(date)) / 86400000);
  if (days <= 0) return 'Today';
  if (days === 1) return 'Yesterday';
  if (days < 7) return `${days} days ago`;
  return date.toLocaleDateString('en-NZ', { day: 'numeric', month: 'long', year: 'numeric' });
};

export const greetingFor = (name) => {
  const hour = new Date().getHours();
  const part = hour < 12 ? 'morning' : hour < 18 ? 'afternoon' : 'evening';
  return `Good ${part}, ${firstNameOf(name)}`;
};
